<template>
  <div class="home">
    <!-- Hero Section -->
    <section class="hero text-center py-5 position-relative">
      <div class="hero-background"></div>
      <div class="container position-relative" style="z-index: 2;">
        <h1 class="display-3 fw-bold mb-3 text-white">Bienvenid@</h1>
        <p class="lead mb-4 text-white">Una sala de Yoga situada en el corazón del Cabanyal</p>
        <RouterLink to="/nuestras-practicas" class="btn btn-primary btn-lg">
          Descubre nuestras clases
        </RouterLink>
      </div>
    </section>

    <!-- Feliz año section -->
     <!--
    <section class="new-year py-5 bg-light">
      <div class="container">
        <div class="row g-4 justify-content-center">
          <div class="col-lg-5 col-md-6">
            <div class="announcement-card">
              <img src="/images/feliz-anyo-2026.jpg" alt="Feliz año 2026" class="img-fluid rounded shadow">
            </div>
          </div>
          <div class="col-lg-5 col-md-6">
            <div class="announcement-card">
              <img src="/images/agenda-enero-2026.jpg" alt="Agenda Enero 2026" class="img-fluid rounded shadow">
            </div>
          </div>
        </div>
      </div>
    </section>
  -->

    <!-- Beneficios del Yoga -->
    <section class="benefits py-5">
      <div class="container">
        <h2 class="text-center mb-5">Yoga: El camino hacia el bienestar físico, mental, emocional y espiritual.</h2>
        
        <div class="row g-4">
          <!-- Bloque 1: Calma mental -->
          <div class="col-lg-3 col-md-6">
            <div class="benefit-card text-center h-100 p-4">
              <img src="/images/calma-y-equilibrio-mental.png" alt="Calma mental" class="benefit-icon mb-3">
              <h3 class="h5 mb-3">Calma y equilibrio mental</h3>
              <p>El yoga junto a la meditación favorecen a la producción de serotonina, melatonina y activa el sistema parasimpático, lo que favorece un estado de calma y tranquilidad. También es una potente herramienta para la gestión emocional, que nos ayuda a hacer frente a nuestro cotidiano de una manera más positiva.</p>
            </div>
          </div>

          <!-- Bloque 2: Salud física -->
          <div class="col-lg-3 col-md-6">
            <div class="benefit-card text-center h-100 p-4">
              <img src="/images/salud-y-fortaleza-fisica.png" alt="Salud física" class="benefit-icon mb-3">
              <h3 class="h5 mb-3">Salud y fortaleza física</h3>
              <p>La práctica de yoga mejora la circulación sanguínea y aumenta la fuerza de los músculos respiratorios. Fortalece los músculos y los huesos y potencia la flexibilidad articular. Contribuye a aliviar dolores crónicos y posturales.</p>
            </div>
          </div>

          <!-- Bloque 3: Vitalidad -->
          <div class="col-lg-3 col-md-6">
            <div class="benefit-card text-center h-100 p-4">
              <img src="/images/aumento-de-la-vitalidad.png" alt="Vitalidad" class="benefit-icon mb-3">
              <h3 class="h5 mb-3">Aumento de la vitalidad y la energía</h3>
              <p>La práctica habitual y progresiva de yoga disminuye el estado de ansiedad y estrés. Aumenta la vitalidad y la energía, mejora el funcionamiento interno de los órganos a través de prácticas respiratorias específicas (pranayamas), y del trabajo de asana.</p>
            </div>
          </div>

          <!-- Bloque 4: Flexibilidad -->
          <div class="col-lg-3 col-md-6">
            <div class="benefit-card text-center h-100 p-4">
              <img src="/images/mayor-flexibilidad.png" alt="Flexibilidad" class="benefit-icon mb-3">
              <h3 class="h5 mb-3">Mayor flexibilidad física y mental</h3>
              <p>La práctica regular aumentará la flexibilidad de tu cuerpo, haciéndote adoptar posturas más saludables y a medida que esto suceda, tu mente, la forma de tomarte la vida también será más flexible. Parar, observar y escuchar nuestro cuerpo nos ofrece una visión más amplia y profunda de quienes somos.</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Horarios -->
    <section class="schedule py-5 bg-light">
      <div class="container text-center">
        <h2 class="mb-3">Nuestro horario semanal</h2>
        <p class="lead mb-4">Salud, la consciencia, la energía y la integración.</p>
        <div class="schedule-image-container">
          <img src="/images/2026/abril/horarios.jpeg" alt="Horario semanal" class="img-fluid rounded shadow">
        </div>
      </div>
    </section>

    <!-- Filosofía -->
    <section class="philosophy py-5">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-10">
            <p class="lead text-center">
              Nuestras clases están impregnadas de Amor, a veces de humor, pero sobre todo Amor ante la persona que se sitúa frente a nosotros, ya que no es más que un puro reflejo de nuestra luces y nuestras sombras, así que con amor y un profundo sentimiento de respeto abrimos la sala a las personas que llegan hasta Cabanyal Dojo.
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- Tarjetas de Actividades -->
    <section class="activities py-5 bg-light">
      <div class="container">
        <div class="row g-4">
          <!-- Tarjeta 1: Clases -->
          <div class="col-lg-4 col-md-6">
            <div class="card h-100 shadow-sm">
              <img src="/images/clases-de-yoga.jpg" alt="Clases de Yoga" class="card-img-top" style="height: 250px; object-fit: cover;">
              <div class="card-body text-center">
                <h3 class="card-title h4 mb-3">Clases de Yoga</h3>
                <p class="card-text">Queremos que puedas elegir la práctica que más se adapte a condición física, emocional y espiritual.</p>
                <RouterLink to="/nuestras-practicas" class="btn btn-outline-primary">
                  Ver Prácticas
                </RouterLink>
              </div>
            </div>
          </div>

          <!-- Tarjeta 2: Retiros -->
          <div class="col-lg-4 col-md-6">
            <div class="card h-100 shadow-sm">
              <img src="/images/nuestros-retiros.jpg" alt="Retiros de Yoga" class="card-img-top" style="height: 250px; object-fit: cover;">
              <div class="card-body text-center">
                <h3 class="card-title h4 mb-3">Nuestros Retiros de Yoga</h3>
                <p class="card-text">Realizamos de 3 a 4 retiros anuales dónde hacemos una inmersión profunda en la práctica de yoga así como en la desconexión de lo cotidiano.</p>
                <RouterLink to="/retiros" class="btn btn-outline-primary">
                  Ver Retiros
                </RouterLink>
              </div>
            </div>
          </div>

          <!-- Tarjeta 3: Actividades -->
          <div class="col-lg-4 col-md-6">
            <div class="card h-100 shadow-sm">
              <img src="/images/actividades-fin-de-semana.jpg" alt="Actividades de fin de semana" class="card-img-top" style="height: 250px; object-fit: cover;">
              <div class="card-body text-center">
                <h3 class="card-title h4 mb-3">Actividades de fin de semana</h3>
                <p class="card-text">Descubre nuestras actividades conscientes los fines de semana.</p>
                <RouterLink to="/horarios-actividades" class="btn btn-outline-primary">
                  Ver Actividades
                </RouterLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Testimonios -->
    <section class="testimonials py-5">
      <div class="container">
        <h2 class="text-center mb-5">Testimonios de nuestros alumnos</h2>
        <div class="row justify-content-center">
          <div class="col-lg-8">
            <div class="testimonial-card p-4 shadow-sm bg-light rounded">
              <blockquote class="blockquote text-center">
                <p class="mb-3 fs-5">"Las clases de Hatha Yoga dinámico son una maravilla! Las profes son una pasada, muy atentas y súper profesionales."</p>
                <footer class="blockquote-footer">
                  <strong>Lucía</strong>
                </footer>
              </blockquote>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { RouterLink } from 'vue-router'
</script>

<style scoped>
/* Evitar desbordamiento horizontal */
.home {
  overflow-x: hidden;
}

.hero {
  position: relative;
  min-height: 500px;
  display: flex;
  align-items: center;
  overflow: hidden;
}

.hero-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('/images/bienvenida.jpg');
  background-size: cover;
  background-position: center;
  filter: brightness(0.7);
  z-index: 1;
}

.benefit-icon {
  width: 120px;
  height: auto;
  margin: 0 auto;
  display: block;
  max-width: 100%;
}

/* Contenedor de imagen de horario responsive */
.schedule-image-container {
  max-width: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.schedule-image-container img {
  max-width: 100%;
  height: auto;
  margin: 0 auto;
  display: block;
}

.benefit-card {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.benefit-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

.card {
  border: none;
  transition: transform 0.3s ease;
}

.card:hover {
  transform: translateY(-5px);
}

.testimonial-card {
  border-left: 4px solid var(--color-primary);
}

blockquote {
  font-style: italic;
}

.announcement-card {
  transition: transform 0.3s ease;
}

.announcement-card:hover {
  transform: scale(1.02);
}

/* Asegurar que todas las imágenes sean responsivas */
img {
  max-width: 100%;
  height: auto;
}

/* Responsive para móviles */
@media (max-width: 768px) {
  .hero {
    min-height: 350px;
  }
  
  .hero h1 {
    font-size: 2.5rem;
  }
  
  .hero p.lead {
    font-size: 1.1rem;
  }
  
  .benefit-icon {
    width: 80px;
  }
  
  .benefit-card {
    margin-bottom: 1rem;
  }
  
  h2 {
    font-size: 1.75rem;
  }
  
  .display-3 {
    font-size: 2.5rem;
  }
}

/* Tablets */
@media (min-width: 768px) and (max-width: 991px) {
  .hero {
    min-height: 400px;
  }
  
  .benefit-icon {
    width: 100px;
  }
  
  .schedule-image-container img {
    max-width: 80%;
    margin: 0 auto;
    display: block;
  }
}

/* Desktop grande */
@media (min-width: 1200px) {
  .hero {
    min-height: 600px;
  }
}
</style>

